import { RootState } from '@/store/main';

export const selectProjects = (state: RootState) => state.projects.projects;
export const selectProjectsListForSeries = (state: RootState) => state.projects.projectsListForSeries;
export const selectProjectsListForSeriesMap = (state: RootState) => state.projects.projectsListForSeriesMap;
export const selectProjectsLoading = (state: RootState) => state.projects.projectsLoading;
export const selectProjectsInitialLoaded = (state: RootState) => state.projects.projectsInitialLoaded;
export const selectGetProjectsOptions = (state: RootState) => state.projects.getProjectsOptions;
export const selectGettingProjectsByOption = (state: RootState) => state.projects.gettingProjectByOption;
export const selectGetProjectsListForSeriesOptions = (state: RootState) =>
  state.projects.getProjectsListForSeriesOptions;
export const selectProjectToDelete = (state: RootState) => state.projects.projectToDelete;
export const selectProjectToEdit = (state: RootState) => state.projects.projectToEdit;
export const selectProjectsDisplayView = (state: RootState) => state.projects.projectsDisplayView;
export const selectProjectsList = (state: RootState) => state.projects.projectsList;
export const selectProjectsError = (state: RootState) => state.projects.projectsListError;
export const selectProjectsListLoading = (state: RootState) => state.projects.projectsListLoading;
export const selectProjectsTotals = (state: RootState) => state.projects.projectsTotals;

/* Event/Project groups (aka folders) */
export const selectProjectGroups = (state: RootState) => state.projects.projectGroups;
export const selectSelectedProjectGroup = (state: RootState) => state.projects.selectedProjectGroup;
export const selectProjectGroupTree = (state: RootState) => state.projects.projectGroupTree;
export const selectProjectGroupTreeNameMap = (state: RootState) => state.projects.projectGroupTreeNameMap;
export const selectGettingGroupTree = (state: RootState) => state.projects.gettingGroupTree;
export const selectLoadingProjectGroupsStatus = (state: RootState) => state.projects.loadingProjectGroupsStatus;
export const selectProjectGroupError = (state: RootState) => state.projects.groupError;
export const selectAddProjectsToGroup = (state: RootState) => state.projects.addProjectsToGroup;
export const selectProjectGroupToEdit = (state: RootState) => state.projects.groupToEdit;
export const selectProjectGroupToDelete = (state: RootState) => state.projects.groupToDelete;
export const selectShowCreateProjectGroupModal = (state: RootState) => state.projects.showCreateGroupModal;
